/* eslint-disable */
import ajax from "../JS/ajax";
var qs = require("qs");
export default {
  channel: sessionStorage.getItem('channel') || 'daowayh5',
  inviter: '',
  entry: '',
  appointTime: '',
  technical: {},
  top: false,
  nav: true,
  current: {
    lng: '',
    lat: ''
  },
  couponeInfo: {
    id: "",
    name: "暂无适用代金券",
    bill: 0,
    page: false
  },
  getLocationUrl() {
    var domain = document.domain;
    if (domain.indexOf("daoway.com") != -1) {
      return "https://www.daoway.com/newh52/#";
    } else if (domain.indexOf("daoway.cn") != -1) {
      return "https://www.daoway.cn/newh52/#";
    }
  },
  queryParse(url) {
    url = url || window.location.href;
    var obj = {},
      reg = /([^?=&#]+)=([^?=&#]+)/g;
    url.replace(reg, function () {
      obj[arguments[1]] = arguments[2];
    });
    return obj;
  },
  // 判断设备处于PC还是移动端
  mobileTest() {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      return true
    } else {
      return false
    }
  },
  // 判断安卓或者ios终端
  ckos() {
    let u = navigator.userAgent
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if (isAndroid) {
      return 'android'
    } else if (isiOS) {
      return 'ios'
    } else {
      return 'pc'
    }
  },
  // 判断微信还是其它浏览器
  isWeiXin() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 系统(mobile/pc)
   */
  systemClass() {
    var ua = navigator.userAgent.toLowerCase();
    var android = ua.match(/android/i) == "android";
    var iphone = ua.match(/iphone/i) == "iphone";
    var ipad = ua.match(/ipad/i) == "ipad";
    var ipod = ua.match(/ipod/i) == "ipod";
    var mobile = ua.match(/mobile/i) == "mobile";
    if (android || iphone || ipad || ipod || mobile) {
      return "mobile" //手机版
    } else {
      return "pc" //电脑版
    }
  },
  /**
   * 手机版浏览器
   */
  mobileBrowser() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/micromessenger/i) == "micromessenger") { //微信浏览器
      return "wechat";
    }
    if (ua.indexOf("qq") > -1) { //qq浏览器
      return "qq";
    }
    if (ua.indexOf('baidu') > -1) {//百度浏览器
      return "baidu"
    }
    if (ua.indexOf('alipay') > -1) {//支付宝浏览器
      return "alipay"
    }
    if (ua.indexOf('safari') > -1) {//safari浏览器
      return "safari"
    }
    if (ua.indexOf("inner") > -1) { //app浏览器
      return "inner";
    }
    if (ua.indexOf("alibaichuan") > -1) { //软件内阿里浏览器
      return "alibaichuan";
    }
    return "local"; //本地浏览器
  },
  /**
   * 手机操作系统(ios/android)
   */
  platformSystem() {
    var ua = navigator.userAgent.toLowerCase();
    var ipad = ua.match(/ipad/i) == "ipad";
    var iphone = ua.match(/iphone/i) == "iphone";
    if (ipad || iphone) {
      return "ios"; //iphone操作系统
    } else {
      return "android"; //android操作系统
    }
  },
  /**
   * 手机操作软件
   */
  software() {
    var ua = navigator.userAgent.toLowerCase();
    var ipad = ua.match(/ipad/i) == "ipad";
    var iphone = ua.match(/iphone/i) == "iphone";
    if (ipad || iphone) {
      if (ua.match(/micromessenger/i) == "micromessenger") {
        return "ios_wechat";
      } else if (ua.indexOf("qq") > -1) {
        return "ios_qq";
      } else if (ua.indexOf("weibo") > -1) {
        return "ios_weibo";
      } else {
        return "ios";
      }
    } else {
      if (ua.match(/micromessenger/i) == "micromessenger") {
        return "android_wechat";
      } else if (ua.indexOf("qq") > -1) {
        return "android_qq";
      } else if (ua.indexOf("weibo") > -1) {
        return "android_weibo";
      } else {
        return "android";
      }
    }
  },
  /**
   * 百度事件
   * @param name 网页名称
   * @param operate 事件名称
   */
  baiDuEvent(name, operate) {
    if (this.systemClass() == "pc") {
      _hmt.push(["_trackEvent", name + "-pc版", operate]);
    } else if (this.systemClass() == "mobile") {
      if (this.software() == "ios_wechat") {
        _hmt.push(["_trackEvent", name + "-移动版ios微信浏览器", operate]);
      } else if (this.software() == "ios_qq") {
        _hmt.push(["_trackEvent", name + "-移动版iosQQ浏览器", operate]);
      } else if (this.software() == "ios_weibo") {
        _hmt.push(["_trackEvent", name + "-移动版ios微博浏览器", operate]);
      } else if (this.software() == "ios") {
        _hmt.push(["_trackEvent", name + "-移动版ios(第三方浏览器)", operate]);
      } else if (this.software() == "android_wechat") {
        _hmt.push(["_trackEvent", name + "-移动版android微信浏览器", operate]);
      } else if (this.software() == "android_qq") {
        _hmt.push(["_trackEvent", name + "-移动版androidQQ浏览器", operate]);
      } else if (this.software() == "android_weibo") {
        _hmt.push(["_trackEvent", name + "-移动版android微博浏览器", operate]);
      } else if (this.software() == "android") {
        _hmt.push(["_trackEvent", name + "-移动版android(第三方浏览器)", operate]);
      }
    }
  },
  // 日期格式化
  dateFormat(time, format, other) {
    var t = new Date(time);
    var tf = function (i) {
      return (i < 10 ? '0' : '') + i
    };
    var dayStr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    return format.replace(/appDate|day|yyyy|MM|dd|HH|mm|ss/g, function (a) {
      switch (a) {
        case 'yyyy':
          return tf(t.getFullYear());
          break;
        case 'MM':
          return tf(t.getMonth() + 1);
          break;
        case 'mm':
          return tf(t.getMinutes());
          break;
        case 'dd':
          return tf(t.getDate());
          break;
        case 'HH':
          return tf(t.getHours());
          break;
        case 'ss':
          return tf(t.getSeconds());
          break;
        case 'day':
          var today = new Date();
          if (today.getMonth() + 1 == t.getMonth() + 1) {
            if (today.getDate() == t.getDate()) {
              return "今天";
            } else if (today.getDate() + 1 == t.getDate()) {
              return "明天";
            } else {
              if (other) {
                if (today.getDate() + 2 == t.getDate()) {
                  return "后天";
                }
              } else {
                return dayStr[t.getDay()];
              }
            }
          } else {
            return dayStr[t.getDay()];
          }
          break;
        case 'appDate':
          var today = new Date();
          if (today.getMonth() + 1 == t.getMonth() + 1) {
            if (today.getDate() == t.getDate()) {
              return "今天";
            } else if (today.getDate() + 1 == t.getDate()) {
              return "明天";
            } else {
              return tf(t.getMonth() + 1) + "-" + tf(t.getDate());
            }
          } else {
            return tf(t.getMonth() + 1) + "-" + tf(t.getDate());
          }
      }
    });
  },
  // 日期格式化(日期与时间不补0)
  dateFormatNoRepair(time, format, other) {
    var t = new Date(time);
    var tf = function (i) {
      return i;
    };
    var dayStr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    return format.replace(/appDate|day|yyyy|MM|dd|HH|mm|ss/g, function (a) {
      switch (a) {
        case 'yyyy':
          return tf(t.getFullYear());
          break;
        case 'MM':
          return tf(t.getMonth() + 1);
          break;
        case 'mm':
          return tf(t.getMinutes());
          break;
        case 'dd':
          return tf(t.getDate());
          break;
        case 'HH':
          return tf(t.getHours());
          break;
        case 'ss':
          return tf(t.getSeconds());
          break;
        case 'day':
          var today = new Date();
          if (today.getMonth() + 1 == t.getMonth() + 1) {
            if (today.getDate() == t.getDate()) {
              return "今天";
            } else if (today.getDate() + 1 == t.getDate()) {
              return "明天";
            } else {
              if (other) {
                if (today.getDate() + 2 == t.getDate()) {
                  return "后天";
                }
              } else {
                return dayStr[t.getDay()];
              }
            }
          } else {
            return dayStr[t.getDay()];
          }
          break;
        case 'appDate':
          var today = new Date();
          if (today.getMonth() + 1 == t.getMonth() + 1) {
            if (today.getDate() == t.getDate()) {
              return "今天";
            } else if (today.getDate() + 1 == t.getDate()) {
              return "明天";
            } else {
              return tf(t.getMonth() + 1) + "-" + tf(t.getDate());
            }
          } else {
            return tf(t.getMonth() + 1) + "-" + tf(t.getDate());
          }
      }
    });
  },
  setCookie: function (name, value) {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
    // document.cookie = name + "=" + escape(value); //
  },
  //取Cookie
  getCookie: function (name) {
    var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
    if (arr != null) return unescape(arr[2]);
    return null;
  },
  delCookie: function (name) {//为了删除指定名称的cookie，可以将其过期时间设定为一个过去的时间
    var exp = new Date();
    exp.setTime(exp.getTime() - 10000);
    document.cookie = name + "=0; expires=" + date.toGMTString();
  },
  channelogin: function (phone, sign, channel, inviter) {
    var that = this;
    var url = "/daoway/rest/users/login_channel";
    var datas = {
      channel: channel,
      phone: phone,
      sign: sign,
      inviter: inviter
    }
    ajax
      .post(url, qs.stringify(datas), {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
      .then((res) => {
        var result = res.data;
        if (result.status === "ok") {
          var data = result.data;
          localStorage.setItem("nick", data.nick);
          if (data.phone != undefined && data.phone != null) {
            localStorage.setItem("phone", data.phone);
          } else {
            localStorage.setItem("phone", "");
          }
          localStorage.setItem("userId", data.userId);
          var token = this.getCookie("token");
          localStorage.setItem("token", token);
          this.setCookie("token", token);
          this.getdwvip(data.userId)
        }
      });
  },
  getdwvip(userId) {
    var url =
      "/daoway/rest/vip/" + userId + "/my_vip";
    ajax
      .get(url, {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
      .then((res) => {
        var result = res.data;
        if (result.status === "ok") {
          var data = result.data;
          var dwVip = data.dwVip;
          if (dwVip) {
            localStorage.setItem("dwVip", dwVip);
          }
        }
      });
  },
  loginname() {
    var that = this;
    var url = "/daoway/rest/users/login";
    var name = localStorage.getItem("nick");
    var pwd = localStorage.getItem("pwd");
    if (name && pwd) {
      var datas = {
        user_name: name,
        password: pwd,
        channel: that.channel,
        inviter: that.inviter,
      };
      ajax
        .post(url, qs.stringify(datas), {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then((res) => {

          var result = res.data;
          if (result.status === "ok") {
            var data = result.data;
            if (data.phone != undefined && data.phone != null) {
              localStorage.setItem("phone", data.phone);
            } else {
              localStorage.setItem("phone", "");
            }
            localStorage.setItem("userId", data.userId);
            var token = this.getCookie("token");
            localStorage.setItem("token", token);
            this.setCookie("token", token);
          }
        });
    }
  },
  setwxConfig: function (shareurl) {
    // var url = window.location.href.split('#')[0]
    var urls = "/daoway/rest/config/wxjs?url=" + encodeURIComponent(window.location.href);
    ajax
      .get(urls, {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          client: "DWBM",
        },
      })
      .then((res) => {
        var result = res.data;
        if (result.status === "ok") {
          var data = result.data;
          wx.config({
            debug: false,
            timestamp: data.timestamp,
            appId: data.appId,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsapi_ticket: data.jsapi_ticket,
            "jsApiList": ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", 'getLocation', "checkJsApi", "chooseWXPay"]
          });
          wx.ready(function () {
            var name = "到位 - 上门服务直约平台";
            var title = "好服务来的快！家政、按摩、维修、美容、搬家、养车、外卖...轻松预约，即刻上门。";
            var imgUrl = "https://www.daoway.cn/icon/logo.png";
            var link = shareurl || this.getLocationUrl();
            wx.onMenuShareAppMessage({
              title: name, // 分享标题
              desc: title, // 分享描述
              link: link, // 分享链接
              imgUrl: imgUrl, // 分享图标
              type: 'link', // 分享类型,music、video或link，不填默认为link
              dataUrl: ''
            });
            wx.onMenuShareTimeline({
              title: name + " " + title, // 分享标题
              link: link, // 分享链接
              imgUrl: imgUrl // 分享图标
            });
            wx.onMenuShareQQ({
              title: name, // 分享标题
              desc: title, // 分享描述
              link: link, // 分享链接
              imgUrl: imgUrl // 分享图标
            });
            wx.onMenuShareWeibo({
              title: name, // 分享标题
              desc: title, // 分享描述
              link: link, // 分享链接
              imgUrl: imgUrl // 分享图标
            });
          })
        }
      });
  },
  weixinlogin(page) {
    var locarl = this.getLocationUrl();
    var appid = "wxecbf7975657440f5";
    var loginUrl = encodeURIComponent(locarl + page);
    var scope = "snsapi_userinfo";
    window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + loginUrl + "&response_type=code&scope=" + scope + "&state=STATE#wechat_redirect")
  },
  wxpay2(payInfo, paycode) {
    var url = "";
    var that = this;
    if (payInfo.appendOrderId || payInfo.appendOrderId2) {
      url = "/daoway/rest/pay/wx_h5_prepay_append";
    } else {
      url = "/daoway/rest/pay/wx_h5_prepay";
    }
    if (paycode) {
      // 存储已经使用过的支付code
      var paycodeUsedArray = [];
      try {
        var paycodeUsedValue = localStorage.getItem('paycodeUsedArray');
        if (paycodeUsedValue) {
          paycodeUsedArray = JSON.parse(paycodeUsedValue);
        }
      } catch (e) {
        //TODO handle the exception
      }
      paycodeUsedArray.push(paycode);
      localStorage.setItem("paycodeUsedArray", JSON.stringify(paycodeUsedArray));
      // 存储已经使用过的支付code
      payInfo.oauthCode = paycode;
      payInfo.tradeType = "JSAPI";
      // 百度事件统计
      that.baiDuEvent("确认下单(或订单详情)", "开始微信支付");
      ajax.post(url, qs.stringify(payInfo), {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      }).then((res) => {
        var result = res.data;
        if (result.status === "ok") {
          that.weixinpay(result.data, payInfo.orderId);
        } else {
          // 百度事件统计
          that.baiDuEvent("确认下单(或订单详情)", "微信支付失败(" + result.msg + ")");
          if (result.msg.indexOf("预支付失败") != -1) {
            alert('微信预支付失败，请重新支付');
          } else {
            alert(result.msg);
          }
          var appid = "wxecbf7975657440f5";
          var locationUrl = that.getLocationUrl();
          var loginUrl = encodeURIComponent(locationUrl + "/orderstate?orderId=" + payInfo.orderId)
          var scope = "snsapi_base";
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + loginUrl + "&response_type=code&scope=" + scope + "&state=STATE#wechat_redirect";
        }
      });
    } else {
      that.oauthCode = "";
      payInfo.tradeType = "MWEB";
      ajax.post(url, qs.stringify(payInfo), {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      }).then((res) => {
        var result = res.data;
        if (result.status === "ok") {
          window.location.replace = result.data.mwebUrl;
        } else {
          that.$toast({ msg: result.msg });
        }
      });
    }
  },
  weixinpay(wxdata, orderId) {
    var that = this;
    var url = that.getLocationUrl() + "/orderstate?orderId=" + orderId;
    function onBridgeReady() {
      WeixinJSBridge.invoke("getBrandWCPayRequest", {
        appId: "wxecbf7975657440f5",
        timeStamp: wxdata.timeStamp,
        nonceStr: wxdata.nonceStr,
        package: wxdata.pkg,
        signType: "MD5",
        paySign: wxdata.paySign, //微信签名
      }, (res) => {
        window.setTimeout(function () {
          var appid = "wxecbf7975657440f5";
          var loginUrl = encodeURIComponent(url)
          var scope = "snsapi_base";
          window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + loginUrl + "&response_type=code&scope=" + scope + "&state=STATE#wechat_redirect")
        }, 500);
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          that.$toast({ msg: "支付成功" });
          // 百度事件统计
          that.baiDuEvent("确认下单(或订单详情)", "微信支付成功");
        } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          that.$toast({ msg: "支付取消" });
          // 百度事件统计
          that.baiDuEvent("确认下单(或订单详情)", "微信支付取消");
        } else {
          that.$toast({ msg: "支付失败" });
          // 百度事件统计
          that.baiDuEvent("确认下单(或订单详情)", "微信支付失败(" + JSON.stringify(res) + ")");
        }
      });
    }
    if (typeof WeixinJSBridge == "undefined") {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
      }
      else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
        document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
      }
    }
    else {
      onBridgeReady();
    }
  },
  getposition() {
    var that = this;
    var url = "/daoway/rest/user/city?h5=1"
    ajax
      .get(url, {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
      .then((res) => {
        var result = res.data;
        if (result.status === "ok") {
          var datas = result.data;
          var position = datas.community[0];
          that.position = position;
          localStorage.setItem("position", JSON.stringify(position));
        }
      })
  },
  getlink(userId, pageType, orderId, priceId, serviceId) {
    return new Promise(function (resolve, reject) {
      var url =
        "/daoway/rest/customer/getKFUrl?userId=" +userId+ "&pageType=" + pageType;
        if(orderId){
          url += "&orderId=" + orderId;
        }
        if(priceId){
          url += "&priceId=" + priceId;
        }
        if(serviceId){
          url += "&serviceId=" + serviceId;
        }
      ajax
        .get(url, {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then((res) => {
          var result = res.data;
          if (result.status === "ok") {
            var data = result.data;
            resolve(data.url);
          }
        });
    })
  }
}



// WEBPACK FOOTER //
// ./src/JS/utils.js